import { IProduct, ProductStatus } from '../../shared/models/product.model';
import { EnclosureFlags } from '../../shared/models/enclosure.model';
import { IBomModel } from '../../prisma-xs/models/bom.model';

export interface IProductAccessories {
  additionalBOMEntryId?: number;
  projectId: number;
  description: string;
  reference: string;
  price: number;
  quantity: number;
  enclosureId: number;
  enumber: string | number;
  deliverToPanelBuilder: boolean;
  deliverToCustomer: boolean;
  isCustomDevice?: boolean;
  status?: ProductStatus;
  enclosureFlags?: EnclosureFlags[];
  projectFlags?: EnclosureFlags[];
  productCharacteristicsLink?: string;
  productInfoLink?: string;
  canTransferToWholesaler?: boolean;
  priceBeforeDiscount?: number;
}

export enum GroupedCheckboxSelections {
  ALL = 'all',
  NONE = 'none',
  DIRECT = 'direct',
  PREWIRING = 'prewiring',
  ENCLOSURE_DOCUMENTS = 'enclosure_documents',
  APARTMENT_SPECIFIC = 'apartment_specific'
}

export enum CheckBoxState {
  NONE = 'none',
  INDETERMINATE = 'indeterminate',
  CHECKED = 'checked'
}

export interface BOMDeliveryKindUpdate {
  bomModel: IBomModel;
  isDirectDelivery: boolean;
  tableIdentifier: string;
}

export enum DeliveryTypes {
  TO_CUSTOMER = 'deliverToCustomer',
  TO_PANEL_BUILDER = 'deliverToPanelBuilder'
}

export interface IAdditionalComponentsCatalogueProduct {
  groupName: string;
  products: IProduct[];
}

export interface IAdditionalComponentsCatalogueCart {
  product: IProduct;
  quantity: number;
}

export interface IUpdateBomAccessory {
  additionalBomEntryId: number,
  quantity: number
}
